

exports.__esModule = true;
exports.$guestThrottle = $guestThrottle;

var _angular = require('angular');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/checkout/index');

var _index2 = require('xo-models/src/shippingMethod/index');

function $guestThrottle(flowName, token, lang, country) {
    var models = {};

    function redirectToXoon() {
        return (0, _squid.$dispatch)('xoon', {
            exp: flowName,
            token: token,
            'locale.x': lang + '_' + country,
            'country.x': country
        });
    }

    function fallback(product, reason, params) {
        throw new _squid.$FallbackError({
            product: product || 'ux',
            reason: reason,
            entryPoint: flowName,
            params: params
        });
    }

    function checkShippingRulesExist() {
        if (_angular.$rootScope.wps) {
            return (0, _squid.$populate)(models, {
                checkoutCart: _index.$CheckoutCartModel.instance(token).retrieve(),
                checkoutPayee: _index.$CheckoutPayeeModel.instance(token).retrieve()
            }).then(function () {
                return (0, _squid.$populate)(models, {
                    shippingRulesSummary: _index2.$ShippingRuleSummaryModel.instance(token).retrieve({
                        params: {
                            merchant_id: models.checkoutPayee.merchant.id,
                            currency_code: models.checkoutCart.purchase.amounts.total.currency_code
                        }
                    })
                }).then(function () {
                    var response = models.shippingRulesSummary;

                    if (response.isSnTEnabled && !_squid.$config.enableShippingTaxGuestWPS) {
                        return true;
                    }
                    return;
                });
            });
        } else {
            return _angular.$q.when();
        }
    }

    if (_angular.$rootScope.wps) {
        if (!_squid.$config.enableGuestWps) {
            // Fallback to UX for WPS transactions if guest option disabled
            return fallback('ux', flowName + '_to_ux_wps');
        } else {
            return checkShippingRulesExist().then(function (response) {
                var inventoryGuestFallback = models.checkoutCart.get('cartHasInventory') && !_squid.$config.enableInventoryGuestWPS;

                if (response || inventoryGuestFallback) {
                    if (response) {
                        _logger.$logger.info('snt_enabled_guest_to_ux_wps');
                    } else if (inventoryGuestFallback) {
                        _logger.$logger.info('inventory_enabled_guest_to_ux_wps');
                    }
                    return fallback('ux', 'guest' + '_to_ux_wps');
                } else {
                    return redirectToXoon();
                }
            });
        }
    } else {
        return redirectToXoon();
    }
}

angular.value("$guestThrottle", $guestThrottle);
_angular.$rootScope;

_angular.$q;

_squid.$dispatch;

_squid.$populate;

_squid.$config;

_squid.$FallbackError;

_logger.$logger;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index2.$ShippingRuleSummaryModel;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-login/guestThrottle.js
 ** module id = 180
 ** module chunks = 1
 **/